module.exports = __webpack_public_path__ + "img/blue-rectangle-table-6.9cd2b181.png";